import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] Erro capturado:', error, info);
  }

  handleReload = () => {
    try { localStorage.removeItem('arflow_user'); } catch {}
    window.location.reload();
  };

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg,#3D2800,#5C3D00)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div style={{ background: '#FFFFFF', borderRadius: 20, padding: 40, width: '100%', maxWidth: 420, boxShadow: '0 20px 60px rgba(0,0,0,0.4)', textAlign: 'center' }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>⚠️</div>
            <div style={{ color: '#3D2800', fontWeight: 800, fontSize: 20, fontFamily: 'Georgia,serif', marginBottom: 8 }}>
              Ops, algo deu errado
            </div>
            <div style={{ color: '#8C7A5A', fontSize: 13, marginBottom: 24 }}>
              Ocorreu um erro ao carregar essa tela. Tente novamente ou saia e entre de novo.
            </div>
            {this.state.error && (
              <div style={{ background: '#FFF5EC', border: '1px solid #EDE0C8', borderRadius: 10, padding: 12, fontSize: 11, color: '#C0392B', marginBottom: 20, textAlign: 'left', wordBreak: 'break-word', maxHeight: 120, overflow: 'auto' }}>
                {String(this.state.error.message || this.state.error)}
              </div>
            )}
            <button onClick={this.handleRetry} style={{ width: '100%', background: 'linear-gradient(135deg,#3D2800,#5C3D00)', color: '#C49A50', border: 'none', borderRadius: 10, padding: '13px', fontWeight: 800, fontSize: 15, cursor: 'pointer', letterSpacing: 0.5, marginBottom: 10 }}>
              Tentar novamente
            </button>
            <button onClick={this.handleReload} style={{ width: '100%', background: '#fff', color: '#3D2800', border: '1.5px solid #EDE0C8', borderRadius: 10, padding: '13px', fontWeight: 700, fontSize: 14, cursor: 'pointer' }}>
              Sair e entrar novamente
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
